import React, { FC } from 'react';
import { TextFieldProps } from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import moment, { Moment } from 'moment';

import { DATE_FORMAT } from 'src/shared/constants';
import { MAX_DATE_TIME } from 'src/shared/constants';
import { useTranslate } from 'src/shared/providers';

interface Props extends DatePickerProps<Moment> {
  id?: string;
  error?: boolean | string;
  placeholder?: string;
  readOnly?: boolean;
  allowClear?: boolean;
  onBlur?: TextFieldProps['onBlur'];
}

export const SingleDatePicker: FC<Props> = ({ id, error, placeholder, readOnly, allowClear, onBlur, ...props }) => {
  const { t } = useTranslate();

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        format={DATE_FORMAT.toUpperCase()}
        maxDate={moment(MAX_DATE_TIME)}
        {...props}
        slotProps={{
          ...props.slotProps,
          actionBar: { actions: allowClear ? ['clear', 'today'] : ['today'], ...props.slotProps?.actionBar },
          textField: {
            id,
            color: error ? 'error' : undefined,
            helperText: error,
            error: !!error,
            size: 'small',
            placeholder,
            onBlur,
            ...props.slotProps?.textField,
          },
          field: { readOnly, ...props.slotProps?.field },
        }}
        localeText={{ clearButtonLabel: t('global.clear'), todayButtonLabel: t('global.today'), ...props.localeText }}
        sx={{ width: '100%', ...props.sx }}
      />
    </LocalizationProvider>
  );
};
